import { render, staticRenderFns } from "./button-arrow.vue?vue&type=template&id=3cdcf8b8&scoped=true"
import script from "./button-arrow.vue?vue&type=script&lang=ts"
export * from "./button-arrow.vue?vue&type=script&lang=ts"
import style0 from "./button-arrow.vue?vue&type=style&index=0&id=3cdcf8b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdcf8b8",
  null
  
)

export default component.exports